import {
	IDataListColumn,
	Icon,
	PaginatedAutoDataList,
	PaginatedListFetcherConfig,
	TextButton,
	laravelPaginatedListFetchConfig,
	useToasts,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { eventService } from "../../shared/api/event/eventService";
import { ClippingProviderContactResource } from "../../shared/types";

export const ClippingProviderContactList: FC = () => {
	const { t } = useTranslation();
	const { eventId = "" } = useParams<"eventId">();
	const { showToast } = useToasts();

	const dataListColumns: IDataListColumn<ClippingProviderContactResource>[] = useMemo(
		() => [
			{
				heading: t("Name"),
				valueKey: "name",
				type: "value",
				render: (contact) =>
					contact ? (
						<TextButton
							title={t("Copy contact id")}
							size="small"
							type="button"
							prefix={<Icon $icon="copy" />}
							onClick={() => {
								navigator.clipboard.writeText(`${contact.id}`);
								showToast({ body: t("Contact id successfully copied."), type: "success", title: t("Contact") });
							}}
						>
							{contact.name}
						</TextButton>
					) : null,
			},
			{
				heading: t("Primary company"),
				valueKey: "primaryCompany",
				type: "value",
				render: ({ primaryCompany }) =>
					primaryCompany ? (
						<TextButton
							title={t("Copy company id")}
							size="small"
							type="button"
							prefix={<Icon $icon="copy" />}
							onClick={() => {
								navigator.clipboard.writeText(`${primaryCompany.id}`);
								showToast({ body: t("Company id successfully copied."), type: "success", title: t("Company") });
							}}
						>
							{primaryCompany.name}
						</TextButton>
					) : (
						"-"
					),
			},
			{
				heading: t("Clippings"),
				valueKey: "numberOfClippings",
				type: "value",
			},
		],
		[showToast, t],
	);

	return (
		<PaginatedAutoDataList
			name="clippingProviderContacts"
			heading={`${t("Contacts")} (${t("Clipping provider")}) - ${t("Event")} ${eventId}`}
			empty={t("No contacts available.")}
			columns={dataListColumns}
			listFetchConfig={laravelPaginatedListFetchConfig(
				eventService.clippingProviderContactsKey(eventId),
				(config: PaginatedListFetcherConfig<ClippingProviderContactResource>) =>
					eventService.clippingProviderContacts(config, eventId),
			)}
			initialSearch={{
				search: "",
				searchFields: [
					{ name: "name", label: t("Name") },
					{ name: "primaryCompany", label: t("Primary company") },
				],
			}}
		/>
	);
};
